import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconRadarChartGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g {...(props.group ?? {})}>
      <circle cx="16" cy="16" r="10.25" stroke={fillColor} strokeWidth="1.5" />
      <circle cx="16" cy="16" r="6.25" stroke={fillColor} strokeWidth="1.5" />
      <line
        x1="15.75"
        y1="5"
        x2="15.75"
        y2="26"
        stroke={fillColor}
        strokeWidth="1.5"
      />
      <line
        x1="24.7987"
        y1="9.8815"
        x2="7.7516"
        y2="21.8727"
        stroke={fillColor}
        strokeWidth="1.5"
      />
      <line
        x1="24.3245"
        y1="21.7159"
        x2="7.05019"
        y2="10.0543"
        stroke={fillColor}
        strokeWidth="1.5"
      />
    </g>
  );
};

export const IconRadarChartSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconRadarChartGroup {...props} />
    </svg>
  );
};
